module.exports = __webpack_public_path__ + "img/round2.38e37578.png";